import Shepherd, { StepOptions, Tour } from 'shepherd.js';

export const WelcomeTourSteps: StepOptions[] = [
  {
    id: 'welcome',
    title: 'Welcome to the DaaS Portal',
    text: 'Let us show you around the new dashboard and how to get started.',
    buttons: [
      {
        classes: 'shepherd-button bg-gray-200 text-gray-700 hover:bg-gray-300',
        text: 'Skip',
        action(this: Tour) {
          return this.cancel();
        }
      },
      {
        classes: 'shepherd-button bg-primary-700 text-white hover:bg-primary-800',
        text: 'Next',
        action(this: Tour) {
          return this.next();
        }
      }
    ]
  },
  {
    id: 'standardise',
    title: 'Standardise Products',
    text: 'First, select the products your business intends to use from our master catalogue.',
    attachTo: { element: '#tour-standardise', on: 'bottom' },
    buttons: [
      {
        classes: 'shepherd-button bg-gray-200 text-gray-700 hover:bg-gray-300',
        text: 'Back',
        action(this: Tour) {
          return this.back();
        }
      },
      {
        classes: 'shepherd-button bg-primary-700 text-white hover:bg-primary-800',
        text: 'Next',
        action(this: Tour) {
          return this.next();
        }
      }
    ]
  },
  {
    id: 'bundles',
    title: 'Build Bundles',
    text: 'Next, group your standardized products into convenient bundles for your employees.',
    attachTo: { element: '#tour-bundles', on: 'bottom' },
    buttons: [
      {
        classes: 'shepherd-button bg-gray-200 text-gray-700 hover:bg-gray-300',
        text: 'Back',
        action(this: Tour) {
          return this.back();
        }
      },
      {
        classes: 'shepherd-button bg-primary-700 text-white hover:bg-primary-800',
        text: 'Next',
        action(this: Tour) {
          return this.next();
        }
      }
    ]
  },
  {
    id: 'orders',
    title: 'Order',
    text: 'Finally, place orders or generate quotes for the bundles you\'ve built.',
    attachTo: { element: '#tour-orders', on: 'top' },
    buttons: [
      {
        classes: 'shepherd-button bg-gray-200 text-gray-700 hover:bg-gray-300',
        text: 'Back',
        action(this: Tour) {
          return this.back();
        }
      },
      {
        classes: 'shepherd-button bg-primary-700 text-white hover:bg-primary-800',
        text: 'Finish',
        action(this: Tour) {
          return this.complete();
        }
      }
    ]
  }
];

export const TourDefinitions: Record<string, StepOptions[]> = {
  welcome_tour: WelcomeTourSteps
};
